import React from 'react';
import {LinearProgress, withStyles} from "@material-ui/core";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import BBIconSkullAndBones from "../../../assets/bbCustomIcons/BBIconSkullAndBones";
import BBIconCheckboxCheckedYes from "../../../assets/bbCustomIcons/BBIconCheckboxCheckedYes";
import BBIconShield from "../../../assets/bbCustomIcons/BBIconShield";
import BBIconRadarSweepWithTargets from "../../../assets/bbCustomIcons/BBIconRadarSweepWithTargets";
import {Col, Row} from "reactstrap";


const BorderLinearProgressDeterminate = withStyles((theme) => ({
    root: {
        height: 15,
        borderRadius: 5,
        // marginTop: -10,
        margin: 0,
    },
    dashed: {
        height: 20,
        lineHeight: 10,
    },
    colorPrimary: {
        // backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 100 : 700],
        backgroundColor: theme.palette.grey[400],
        // backgroundColor: "#263440"
    },
    bar: {
        // borderRadius: 5,
        backgroundColor: "#28368B",
    },
    bar1Buffer: {
        // borderRadius: 5,
        backgroundColor: "#0B154D",
    },
}))(LinearProgress);

const ThreatsStatusProgress = ({currentStatus=null,
                               currentStep=null,
                               vectorCard = false,
                               vector = null,}) => {


    // const steps = ['Identified', 'Verified', 'Testing', " /"]
    const steps = {
        0 : {name: "Discovered",
            description: "This threat was identified as a possible attack vector. Next the threat will be verified, tested, and proved.",
            step: "1",
            icon: null} ,
        1 : {name: "Verified",
            description: "Preliminary findings indicate that this threat could be a potential point of attack. Next the threat will be tested and proved.",
            step: "2",
            icon: null} ,
        2 : {name: "Tested",
            description: "Penetration testing has been conducted against this threat and will continue to take place over time.",
            step: "3",
            icon: null} ,
        3 : {name: "Breached",
            description: "One or more attacks have been successful. This means this threat is open to possible exploitation by hackers. Action is required. ",
            step: "4",
            icon: <BBIconSkullAndBones />} ,
    }

    const totalSteps= Object.keys(steps).length;

    // const completedSteps = Object.keys(currentStatus).filter((obj)=> currentStatus[obj] === true);
    //
    // currentStep === null && const currentStep =  Object.keys(currentStatus).filter((obj)=> currentStatus[obj] === true).pop();

    // const currentStep = '2';
    // console.log(currentStep)
    const getThreatStatus = (vector)=> {
        let currentStep;
        if (vector.is_breached) {
            return currentStep = 3;
            // "One or more attacks have been successful. This means this threat is open to possible exploitation by hackers. Action is required."
        } else if (vector.is_tested) {
            return currentStep = 2;
            // "Attack actions against this threat are taking place. We will report whether your current defenses are able to stop the testing attacks."
        } else if (vector.is_validated) {
            return currentStep = 1;
            // "Preliminary findings indicate that this threat could be a potential point of attack. Next the threat will be tested and proved."
        } else if (vector.is_discovered) {
            return currentStep = 0;
            // "This threat was identified as a possible attack vector. Next the threat will be verified, tested, and proved."}
        } else {
            return currentStep = 4;
            // "Status Pending..."
        }
    }

    if(!currentStep && vector){
        currentStep = getThreatStatus(vector)
    }
    if(currentStep != null && currentStep >= 0 && currentStep <= 3){
        return (
            <div className="m-0 p-0">
                <Tooltip title={`${steps[currentStep].description}`}>
                <span>
                    <BorderLinearProgressDeterminate variant="determinate" value={((Number(currentStep) + 1) / Number(totalSteps)) * 100}/>
                    <Row className={"text-right d-print-table-row"}>

                        {vectorCard && <Col> </Col>}
                        <Col className={"d-print-inline"} lg={currentStep === 0 ? 3 : 2} >{currentStep === 0
                            ? <span className="m-0 p-0">
                                <BBIconRadarSweepWithTargets style={{fontSize: "18px"}}/>Identified</span>
                            : <span>1</span>}
                        </Col>{(currentStep === 0 && !vectorCard) && <Col> </Col>}

                        <Col className={"d-print-inline"} lg={currentStep === 1 ? 3 : 2}>
                            {currentStep === 1
                                ? <span className="m-0 p-0"><BBIconCheckboxCheckedYes/>Verified </span>
                                : <span>2</span>}
                        </Col>{(currentStep === 1 && !vectorCard) && <Col> </Col>}

                        <Col className={"d-print-inline"} lg={currentStep === 2 ? 3 : 2}>
                            {currentStep === 2
                                ? <span className="m-0 p-0"><BBIconShield/>Tested </span>
                                : <span>3</span>}
                        </Col>{(currentStep === 2 && !vectorCard) && <Col> </Col>}

                        <Col className={"d-print-inline"} lg={currentStep === 3 ? 3 : 2}>
                            {currentStep === 3
                                ? <span className="m-0 p-0"><BBIconSkullAndBones style={{color: 'red'}}/>Breached </span>
                                : <span>4</span>}
                        </Col>{(currentStep === 3 && !vectorCard) && <Col> </Col>}

                        {vectorCard && <Col> </Col>}
                    </Row>
                    {vectorCard &&
                    <Row className={"mt-2"}>
                        <Col lg={12}>
                            <p style={{color: "darkslategray"}}><em>{steps[currentStep].description}</em></p>
                        </Col>
                    </Row>
                    }
                        {/*<Col> </Col>*/}
                        {/*{currentStep === 0 && <span className="m-0 p-0">{<BBIconRadarSweepWithTargets/>}Identified--- 2 --- 3 --- 4 </span>}*/}
                        {/*{currentStep === 1 && <span className="m-0">1 --- {<BBIconCheckboxCheckedYes/>} Verified --- 3 --- 4 </span>}*/}
                        {/*{currentStep === 2 && <span className="m-0">1 ---  2 --- {<BBIconShield/>} Testing --- 4 </span>}*/}
                        {/*{currentStep === 3 && <span className="m-0">1 --- 2 --- 3 --- {<BBIconSkullAndBones style={{color: 'red'}}/>}Breached </span>}*/}
                </span>
                </Tooltip>
            </div>

        )
    } else {
        console.warn("Unexpected currentStep in progress bar:", currentStep);
        return (
            <div style={{width: "100%"}}>
                <span>
                    <BorderLinearProgressDeterminate variant="determinate" value={0}/>
                    <Row className={"col-12 text-center d-print-table-row"}>

                        <Col lg={12}>

                        </Col>
                    </Row>
                    {vectorCard &&
                    <Row className={"mt-2"}>
                        <Col lg={12}>
                            <p style={{color: "darkslategray"}}><em>Pending...</em></p>
                        </Col>
                    </Row>
                    }
                </span>
            </div>

        )

    }

}

export default ThreatsStatusProgress;